import api from './api'

interface LoginData {
  email: string
  password: string
}

interface RegisterData {
  email: string
  password: string
  name?: string
}

interface AuthResponse {
  access_token: string
  token_type: string
}

interface OTPResponse {
  requires_otp: boolean
  otp_session: string
  message: string
  user: {
    email: string
    name: string
  }
}

interface VerifyOTPData {
  otp_session: string
  otp_code: string
}

export const authService = {
  // Step 1: Login with credentials - returns OTP session
  async login(data: LoginData): Promise<AuthResponse | OTPResponse> {
    const response = await api.post('/auth/login', {
      email: data.email,
      password: data.password
    })
    
    // If OTP required, return without storing token
    if (response.data.requires_otp) {
      return response.data as OTPResponse
    }
    
    // Direct login (fallback for legacy)
    const token = response.data.access_token
    if (token) {
      localStorage.setItem('access_token', token)
    }
    
    return response.data
  },

  // Step 2: Verify OTP code and get token
  async verifyOTP(data: VerifyOTPData): Promise<AuthResponse> {
    console.log('[Auth] verifyOTP called')
    const response = await api.post('/auth/verify-otp', data)
    console.log('[Auth] verifyOTP response:', response.data)
    
    const token = response.data.access_token
    if (token) {
      localStorage.setItem('access_token', token)
      console.log('[Auth] Token saved to localStorage')
    } else {
      console.error('[Auth] No token in response!')
    }
    
    return response.data
  },

  // Resend OTP code
  async resendOTP(email: string): Promise<OTPResponse> {
    const response = await api.post('/auth/resend-otp', { email })
    return response.data
  },

  async register(data: RegisterData): Promise<OTPResponse> {
    const response = await api.post('/auth/register', data)
    return response.data
  },

  async getMe(): Promise<{ id: number; email: string; name: string; plan?: string; [key: string]: unknown }> {
    const response = await api.get('/auth/me')
    return response.data
  },

  logout(): void {
    localStorage.removeItem('access_token')
  },

  getToken(): string | null {
    return localStorage.getItem('access_token')
  },

  setToken(token: string): void {
    localStorage.setItem('access_token', token)
  },

  isAuthenticated(): boolean {
    return !!this.getToken()
  }
}
